<template>
  <b-container fluid>
    <b-alert
      variant="success"
      :show="dismissCountDown1"
      v-if="packageCreated===1"
      @dismissed="dismissPackageCreated"
      @dismiss-count-down="countDownChanged1">
      Пакет номер <b>{{ chainPid }}</b> <i class="fas fa-copy copy-td"
                                           v-b-tooltip.hover
                                           title="Копировать"
                                           id="alertCreate"
                                           @click="copyPkgNumber('alertCreate', 'add', $event)"
                                           @mouseleave="resetTooltip('alertCreate', $event)"></i> успешно создан!
    </b-alert>
    <b-alert
      variant="success"
      :show="dismissCountDown2"
      v-if="packageEdited===1"
      @dismissed="dismissPackageEdited"
      @dismiss-count-down="countDownChanged2">
      Пакет номер <b>{{ chainId }}</b> <i class="fas fa-copy copy-td"
                                          v-b-tooltip.hover
                                          title="Копировать"
                                          id="alertEdit"
                                          @click="copyPkgNumber('alertEdit', 'edit', $event)"
                                          @mouseleave="resetTooltip('alertEdit', $event)"></i> успешно
      отредактирован!
    </b-alert>

    <b-row v-if="mobile">
      <b-col md="6" class="mb-2">
        <b-form-select id="select-status" v-model="current_status" @change="recalcItemsLength">
          <option :value="undefined">Все статусы</option>
          <option v-for="(item, index) in statuses" :key="index" :value="item">{{ item }}</option>
        </b-form-select>
      </b-col>
      <b-col md="6" class="mb-2">
        <b-input-group class="search">
          <b-form-input v-model="filter" placeholder="Поиск"/>
          <div class="container_search-close" @click="clearField">
            <span class="search-close">&#215;</span>
          </div>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row v-if="tablet">
      <b-col md="12" class="d-flex align-items-center justify-content-between mb-2">
        <b-form-select style="width: calc(50% - 8px)" id="select-status" v-model="current_status"
                       @change="recalcItemsLength">
          <option :value="undefined">Все статусы</option>
          <option v-for="(item, index) in statuses" :key="index" :value="item">{{ item }}</option>
        </b-form-select>

        <b-input-group class="search" style="width: calc(50% - 8px)">
          <b-form-input v-model="filter" placeholder="Поиск"/>
          <div class="container_search-close" @click="clearField">
            <span class="search-close">&#215;</span>
          </div>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row v-if="mobile || tablet">
      <b-col sm="12" class="d-flex align-items-center justify-content-between mb-2">
        <b-button
          size="md"
          @click="openFormToAddConsignment"
          id="create-new-consignment"
          variant="success"><span>Создать заявку</span>
        </b-button>
        <b-button
          size="md"
          id="find-consignments"
          @click="reloadConsignments"
          :disabled="isBusy"
          variant="primary"><span>Обновить</span>
        </b-button>
      </b-col>
    </b-row>

    <b-row v-if="desktop || largeDesktop">
      <b-col md="3" class="mb-2">
        <b-form-select id="select-status" v-model="current_status" @change="recalcItemsLength">
          <option :value="undefined">Все статусы</option>
          <option v-for="(item, index) in statuses" :key="index" :value="item">{{ item }}</option>
        </b-form-select>
      </b-col>
      <b-col md="9" sm="9" class="pl-0 mb-2">
        <div class="d-flex">
          <b-input-group class="search">
            <b-form-input v-model="filter" placeholder="Поиск"/>
            <div class="container_search-close" @click="clearField">
              <span class="search-close">&#215;</span>
            </div>
          </b-input-group>
          <div class="d-flex">
            <b-button
              id="create-new-consignment"
              variant="success"
              @click="openFormToAddConsignment"
              class="ml-3 mr-3">
              <i class="fas fa-plus"></i><span>Создать заявку</span>
            </b-button>
            <b-button
              id="find-consignments"
              @click="reloadConsignments"
              :disabled="isBusy"
              variant="primary">
              <i class="fas fa-sync-alt"></i><span>Обновить список</span>
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>

    <div v-if="this.consignments && this.consignments.length " class="filtered-items-number">Записи с
      {{ currentPage === 1 ? this.setFirstItem() : ((currentPage-1)*this.pageOptionSelected)+1 }} до
      {{ this.calcItems() }} из {{ this.parsedConsignments.length }} (отфильтровано из {{ this.consignments.length }}
      записей)
    </div>

    <b-table
      hover
      show-empty
      :striped="striped"
      :stacked="stacked"
      :fixed="fixed"
      id="data_table"
      :fields="fields"
      :items="parsedConsignments"
      :busy="isBusy"
      :no-provider-paging="true"
      :no-provider-sorting="true"
      :no-provider-filtering="true"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      @row-hovered="rowHowered"
      @row-unhovered="rowUnhowered"
      class="data_table_pi_transit mt-3 blue"
      empty-text="Нет данных в таблице"
      empty-filtered-text="Нет данных по вашему запросу">

      // загрузчик
      <div slot="table-busy" class="text-center text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загрузка...</strong>
      </div>

      // Накладная
      <template v-slot:head(status)="data">
        <i v-if="largeDesktop" class="fas fa-file-alt"></i>{{ data.label }}
      </template>
      <template v-slot:cell(status)="row">
        <div v-if="mobile" class="d-flex justify-content-between">
          <div v-if="row.item.waybill" class="invoice-wrapper">
            <span class="invoice">{{ row.item.waybill }}</span>
          </div>
          <div class="status-wrapper d-flex align-items-center">
            <b-badge class="status-badge" tag="div" v-if="row.value" :variant="row.value.display_as">
              {{ row.value.caption }}
            </b-badge>
          </div>
        </div>
        <div v-if="tablet" class="d-flex align-items-center justify-content-between">
          <div class="invoice-wrapper d-flex align-items-center">
            <span class="invoice">{{ row.item.waybill ? row.item.waybill : 'XXXXXXXX' }}</span>
          </div>
          <div class="status-wrapper d-flex align-items-center pl-2">
            <b-badge class="status-badge" tag="div" v-if="row.value" :variant="row.value.display_as">
              {{ row.value.caption }}
            </b-badge>
            <div v-if="row.item.can_edit && !!row.item.declarant_comment"
                 class="reply-icon-wrapper ml-2"
                 v-b-tooltip.hover
                 :title="row.item.declarant_comment ? row.item.declarant_comment : ''">
              <i class="fas fa-question-circle text-danger"></i>
            </div>
          </div>
        </div>
        <div v-if="desktop || largeDesktop">
          <div v-if="row.item.waybill" class="invoice-wrapper">
            <i v-if="largeDesktop && !desktop" class="fas fa-file-invoice"></i>
            <span class="invoice">{{ row.item.waybill }}</span>
            <i v-if="row.item.actions.visible"
               class="fas fa-copy copy-td"
               v-b-tooltip.hover
               title="Копировать"
               :id="row.item.waybill"
               @click="copyTextToClipboard(row.item.waybill, row.item.waybill, $event)"
               @mouseleave="resetTooltip(row.item.waybill, $event)">
            </i>
          </div>
          <div class="status-wrapper d-flex align-items-center">
            <b-badge class="status-badge" tag="div" v-if="row.value" :variant="row.value.display_as">
              {{ row.value.caption }}
            </b-badge>
            <div v-if="row.item.can_edit && !!row.item.declarant_comment"
                 class="reply-icon-wrapper ml-2"
                 v-b-tooltip.hover
                 :title="row.item.declarant_comment ? row.item.declarant_comment : ''">
              <i class="fas fa-question-circle text-danger"></i>
            </div>
          </div>
        </div>
      </template>

      // Транспорт
      <template v-slot:head(transport)="data">
        <i v-if="largeDesktop" class="fas fa-truck"></i>{{ data.label }}
      </template>
      <template v-slot:cell(transport)="row">
        <div v-if="mobile">{{ row.value }}</div>
        <div v-if="tablet" class="vehicle d-flex align-items-center justify-content-between">
          <div><i class="fas fa-file-invoice"></i> {{ row.item.declaration }}</div>
          <div class="pl-2"><i class="fas fa-truck-moving"></i> {{ row.value }}</div>
        </div>
        <div v-if="desktop || largeDesktop">{{ row.value }}</div>
      </template>

      // Станция открытия транзита
      <template v-slot:head(transite_open)="data">
        <i v-if="largeDesktop" class="fas fa-monument"></i>{{ data.label }}
      </template>
      <template v-slot:cell(transite_open)="row">
        <div v-if="mobile" class="transit-wrapper">
          <span v-if="row.value.date">{{ convertDate(row.value.date)}}&nbsp;|&nbsp;</span><span>{{ row.value.station ? row.value.station : '' }}</span>
        </div>
        <div v-if="tablet" class="d-flex align-items-center justify-content-between">
          <div class="transit-wrapper" v-if="row.value.date">
            <div class="transit-station">
              <i class="fas fa-door-open"></i> {{ convertDate(row.value.date) }} | {{ row.value.station ?
              row.value.station : '' }}
            </div>
          </div>
          <div v-else class="transit-wrapper d-flex">
            <div class="transit-station"><i class="fas fa-door-open"></i> {{ row.value.station ? row.value.station : ''
              }}
            </div>
          </div>
          <div class="transit-wrapper pl-2" v-if="row.item.transite_close.date">
            <div class="transit-station">
              <i class="fas fa-door-closed"></i> {{ convertDate(row.item.transite_close.date) }} | {{
              row.item.transite_close.station ? row.item.transite_close.station : '' }}
            </div>
          </div>
          <div v-else class="transit-wrapper d-flex pl-2">
            <div class="transit-station"><i class="fas fa-door-closed"></i> {{ row.value.station ? row.value.station :
              '' }}
            </div>
          </div>
        </div>
        <div v-if="desktop">
          <div v-if="row.item.transite_open.date">
            <div class="mb-1 transit-wrapper">
              <i class="fas fa-door-open"></i><span v-if="largeDesktop" class="mr-2 transit-status">Открыт:</span><span
              class="transit-date">{{ convertDate(row.item.transite_open.date)}}</span>
            </div>
            <div class="transit-station" :style="{'margin-left': row.item.transite_open.date ? '28px' : '20px'}">
              {{ row.item.transite_open.station ? row.item.transite_open.station : '' }}
            </div>
          </div>
          <div v-else class="mb-1 transit-wrapper d-flex">
            <i class="fas fa-door-open mr-2"></i><span
            class="transit-station">{{ row.item.transite_open.station ? row.item.transite_open.station : '' }}</span>
          </div>
          <div v-if="row.item.transite_close.date && desktop">
            <div class="mb-1 transit-wrapper">
              <i class="fas fa-door-closed"></i><span v-if="largeDesktop"
                                                      class="mr-2 transit-status">Закрыт:</span><span
              class="transit-date">{{ convertDate(row.item.transite_close.date) }}</span>
            </div>
            <div class="transit-station" :style="{'margin-left': row.item.transite_close.date ? '28px' : '20px'}">
              {{ row.item.transite_close.station ? row.item.transite_close.station : '' }}
            </div>
          </div>
          <div v-else class="mb-1 transit-wrapper d-flex">
            <i class="fas fa-door-closed mr-2"></i><span
            class="transit-station">{{ row.item.transite_close.station ? row.item.transite_close.station : '' }}</span>
          </div>
        </div>
        <div v-if="largeDesktop">
          <div v-if="row.item.transite_open.date">
            <div class="mb-1 transit-wrapper">
              <i class="fas fa-door-open"></i><span v-if="largeDesktop" class="mr-2 transit-status">Открыт:</span><span
              class="transit-date">{{ convertDate(row.item.transite_open.date)}}</span>
            </div>
            <div class="transit-station" :style="{'margin-left': row.item.transite_open.date ? '28px' : '20px'}">
              {{ row.item.transite_open.station ? row.item.transite_open.station : '' }}
            </div>
          </div>
          <div v-else class="mb-1 transit-wrapper d-flex">
            <i class="fas fa-door-open mr-2"></i><span
            class="transit-station">{{ row.item.transite_open.station ? row.item.transite_open.station : '' }}</span>
          </div>
        </div>
      </template>

      // Станция закрытия транзита
      <template v-slot:head(transite_close)="data">
        <i v-if="largeDesktop" class="fas fa-monument"></i>{{ data.label }}
      </template>
      <template v-slot:cell(transite_close)="row">
        <div v-if="mobile || tablet">
          <div v-if="row.value.date" class="transit-wrapper">
            {{ convertDate(row.value.date) }} | {{ row.value.station ? row.value.station : '' }}
          </div>
          <div v-else class="transit-wrapper">{{ row.value.station ? row.value.station : '' }}</div>
        </div>
        <div v-if="desktop || largeDesktop">
          <div v-if="row.value.date">
            <div class="mb-1 transit-wrapper">
              <i class="fas fa-door-closed"></i><span class="mr-2 transit-status">Закрыт:</span><span
              class="transit-date">{{ convertDate(row.value.date) }}</span>
            </div>
            <div class="transit-station" :style="{'margin-left': row.value.date ? '28px' : '20px'}">
              {{ row.value.station ? row.value.station : '' }}
            </div>
          </div>
          <div v-else class="mb-1 transit-wrapper d-flex">
            <i class="fas fa-door-closed mr-2"></i><span
            class="transit-station">{{ row.value.station ? row.value.station : '' }}</span>
          </div>
        </div>
      </template>

      // Номер ЭТД
      <template v-slot:head(declaration)="data">
        <i v-if="largeDesktop" class="fas fa-barcode"></i>{{ data.label }}
      </template>
      <template v-slot:cell(declaration)="row">
        <div v-if="row.value">
          <div class="mb-1 td-number-wrapper">
            <span class="td-number">{{ row.value }}</span>
            <i class="fas fa-copy copy-td"
               v-if="row.item.actions.visible"
               v-b-tooltip.hover
               title="Копировать"
               :id="row.item.declaration"
               @click="copyTextToClipboard(row.item.declaration, row.item.declaration, $event)"
               @mouseleave="resetTooltip(row.item.declaration, $event)">
            </i>
          </div>
        </div>
      </template>

      // Пакет
      <template v-slot:head(chain_id)="data">
        <i v-if="largeDesktop" class="fas fa-file-download"></i>{{ data.label }}
      </template>
      <template v-slot:cell(chain_id)="row">
        <div v-if="mobile" class="d-flex justify-content-between">
          <div>{{ row.value }} от {{ convertDate(row.item.create_date) }}</div>
          <div style="width: 50%; position: relative" class="d-flex align-items-center">
            <b-button
              class="action-button"
              style="position: absolute; top: -10px; right: 0px; width: 34px; height:34px"
              size="sm"
              variant="secondary"
              @click="openDocuments(row, row.item.chain_id, row.item.pi_pid, row.item.consignment_id, row.item.print_docs, row.item.transite_pid, row.item.print_pi_docs)">
              <i class="fas fa-paperclip"></i>
            </b-button>
            <b-button
              style="position: absolute; top: -10px; right: 42px; width: 34px; height:34px"
              size="sm"
              @click="openFormToEditConsignment(row.item.chain_id, row.item.pi_pid, row.item.declarant_comment, row.item.consignment_id)"
              v-if="row.item.can_edit"
              class="ml-2"
              variant="danger action-button">
              <i class="fas fa-reply"></i>
            </b-button>
          </div>
        </div>
        <div v-if="tablet" class="d-flex justify-content-between">
          <div class="consignment"><i class="fas fa-box"></i> {{ row.value }} от {{ convertDate(row.item.create_date) }}
          </div>
          <div style="width: 50%; position: relative" class="d-flex align-items-center">
            <b-button
              class="action-button"
              style="position: absolute; top: -10px; right: 0px; width: 34px; height:34px"
              size="sm"
              variant="secondary"
              @click="openDocuments(row, row.item.chain_id, row.item.pi_pid, row.item.consignment_id, row.item.print_docs, row.item.transite_pid, row.item.print_pi_docs)">
              <i class="fas fa-paperclip"></i>
            </b-button>
            <b-button
              style="position: absolute; top: -10px; right: 42px; width: 34px; height:34px"
              size="sm"
              @click="openFormToEditConsignment(row.item.chain_id, row.item.pi_pid, row.item.declarant_comment, row.item.consignment_id)"
              v-if="row.item.can_edit"
              class="ml-2"
              variant="danger action-button">
              <i class="fas fa-reply"></i>
            </b-button>
          </div>
        </div>
        <div v-if="desktop || largeDesktop">
          <div class="package-number-wrapper"><i class="fas fa-hashtag" v-b-tooltip.hover title="Номер пакета"></i><span
            class="package-number">{{ row.value }}</span></div>
          <div class="created-date-wrapper"><i class="fas fa-clock" v-b-tooltip.hover title="Дата создания"></i><span
            class="created-date">{{ convertDate(row.item.create_date) }}</span>
          </div>
          <div class="user-creator-wrapper"><i class="fas fa-user" v-b-tooltip.hover title="Создатель"></i><span
            class="user-creator">{{ row.item.owner }}</span>
          </div>
        </div>
      </template>

      // Действия
      <template v-slot:head(show_details)="data">
        <i v-if="largeDesktop" class="fas fa-info-circle"></i>{{ data.label }}
      </template>
      <template v-slot:cell(show_details)="row">
        <pi-transit-action-buttons
          ref="actions"
          :visible="row.item.actions.visible"
          :target="row.item.chain_id"
          :can_edit="row.item.can_edit"
          :print_docs="row.item.print_docs"
          @open_documents="openDocuments(row, row.item.chain_id, row.item.pi_pid, row.item.consignment_id, row.item.print_docs, row.item.transite_pid, row.item.print_pi_docs)"
          @edit_consignment="openFormToEditConsignment(row.item.chain_id, row.item.pi_pid, row.item.declarant_comment, row.item.consignment_id)">
        </pi-transit-action-buttons>
      </template>

      // Файлы
      <template slot="row-details" slot-scope="row">
        <div class="attachments-wrapper" v-if="row.item.files && row.item.files.length > 0">
          <div v-for="file in row.item.files" :key="file.id">
            <div v-if="(((file.name !== 'ПИ подтверждено') && (userInfo.piportals[0].alias !== 'otvt')) && ((file.name !== 'Подтверждение о прибытии') && (userInfo.piportals[0].alias !== 'otvt')))"
                 class="attachment"
                 :style="{ width: (desktop || largeDesktop) ? (attachmentWidth + 'px') : '266px', position: 'relative' }"
                 :title="file.name"
                 @click="loadFile($event, file.file, file.name, file.fts, file.fts_pi)">
              <div class="attachment-inner-container">
                <div class="file-icon-wrapper">
                  <i :class="[file.icon, 'file-icon']"></i>
                </div>
                <div class="attachment-name-wrapper">
                  <div class="mb-5 mr-4 file-name">{{ file.name }}</div>
                  <span v-if="file.fts" class="badge badge-success file-date" v-html="convertDate(file.date)"></span>
                  <span v-if="file.size" class="badge badge-secondary file-size" v-html="calcFileSize(file.size)"></span>
                </div>
                <div class="download-file-wrapper"
                     @click="downloadFile($event, file.file, file.name, file.fts, file.fts_pi)" title="Скачать">
                  <i class="fas fa-download"></i>
                </div>
              </div>
            </div>
            <div class="attachment"
                 v-else-if="(userInfo.piportals[0].alias === 'otvt')"
                 :style="{ width: (desktop || largeDesktop) ? (attachmentWidth + 'px') : '266px', position: 'relative' }"
                 :title="file.name"
                 @click="loadFile($event, file.file, file.name, file.fts, file.fts_pi)">
              <div class="attachment-inner-container">
                <div class="file-icon-wrapper">
                  <i :class="[file.icon, 'file-icon']"></i>
                </div>
                <div class="attachment-name-wrapper">
                  <div class="mb-5 mr-4 file-name">{{ file.name }}</div>
                  <span v-if="file.fts" class="badge badge-success file-date" v-html="convertDate(file.date)"></span>
                  <span v-if="file.size" class="badge badge-secondary file-size" v-html="calcFileSize(file.size)"></span>
                </div>
                <div class="download-file-wrapper"
                     @click="downloadFile($event, file.file, file.name, file.fts, file.fts_pi)" title="Скачать">
                  <i class="fas fa-download"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="row.item.files && row.item.files.length === 0" class="text-center no-files">
          В этом пакете нет файлов
        </div>
        <div v-else class="text-center text-secondary my-2">
          <b-spinner class="align-middle mr-2"></b-spinner>
          <strong>Загрузка...</strong>
        </div>
      </template>
    </b-table>

    <div class="main-footer">
      <b-form inline>
        <label v-if="desktop || largeDesktop" class="mr-3">Показать</label>
        <b-form-select :options="pageOptions" v-model="perPage" @change="saveOptionSelected"/>
      </b-form>
      <b-pagination align="center"
                    prev-text="&lt;"
                    first-text="&lt;&lt;"
                    next-text="&gt;"
                    last-text="&gt;&gt;"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-6">
      </b-pagination>
    </div>

    <b-modal id="modalCreateConsignment"
             :title="(desktop || largeDesktop) ? 'Заявка на таможенное оформление груза' : 'Создание заявки'"
             size="lg"
             hide-footer
             @show="showModal"
             @hide="validateChanges"
             @hidden="hideModal">
      <modal-package-form
        :attachmentWidth="attachmentWidth"
        :consignmentsInfo="consignmentsInfo"
        :modalCreateConsignment=true
        :deletedFilesCount="deletedFilesCount"
        @update_consignments_info="updateConsignmentsInfo"
        @save="saveNewConsignment($event)"/>
    </b-modal>

    <b-modal id="modalEditConsignment"
             title="Редактирование заявки"
             size="lg"
             hide-footer
             @show="showModal"
             @hide="validateChanges"
             @hidden="hideModal">
      <modal-package-form
        v-if="openModal"
        :attachmentWidth="attachmentWidth"
        :consignmentsInfo="consignmentsInfo"
        :editFiles="editFiles"
        :data_created_package="data_created_package"
        :message="message"
        :chain_number="chainId"
        :modalEditConsignment=true
        :deletedFilesCount="deletedFilesCount"
        @update_consignments_info="updateConsignmentsInfo"
        @remove="removeFileFromEditedFiles"
        @edit="saveEditedConsignment($event)"/>
      <div v-else class="text-center text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загрузка...</strong>
      </div>
    </b-modal>

    <b-modal
      class="package-modal"
      id="modalLoadFile"
      :title="fileName"
      size="xl"
      hide-footer
      @shown="addStyle"
      @hide="url=null">
      <div class="iframe-wrapper">
        <iframe id="printDocument" :src="url"></iframe>
      </div>
      <i v-if="desktop || largeDesktop" class="fas fa-print modal-print-document" title="Печать"
         @click="printDocument"></i>
      <i v-if="desktop || largeDesktop" class="fas fa-download modal-download-document" title="Скачать"
         @click="downloadFile($event, url, fileName, fts)"></i>
    </b-modal>

    <b-modal
      class="package-modal"
      id="modalLoadFtsMessage"
      :title="fileName"
      size="xl"
      @hidden="hideModal"
      @close="setFtsMessageHtml(null)"
      hide-footer>
      <div v-if="ftsMessageHtml && ftsMessageHtml.length > 0" class="iframe-wrapper">
        <iframe id="printDocumentFts"></iframe>
      </div>
      <div v-else class="text-center text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загрузка...</strong>
      </div>
      <i v-if="ftsMessageHtml && ftsMessageHtml.length > 0 && (desktop || largeDesktop)"
         class="fas fa-print modal-print-document" title="Печать" @click="printDocument"></i>
      <i v-if="ftsMessageHtml && ftsMessageHtml.length > 0 && (desktop || largeDesktop)"
         class="fas fa-download modal-download-document" title="Скачать"
         @click="downloadFile($event, url, fileName, fts, fts_pi)"></i>
    </b-modal>

    <b-modal
      class="package-modal"
      id="modalLoadPiApprovedMessage"
      title="Предварительное информирование подтверждено"
      size="xl"
      @hidden="hideModal"
      @close="setPiApprovedMessageHtml(null)"
      hide-footer>
      <div v-if="piApprovedMessageHtml && piApprovedMessageHtml.length > 0" class="iframe-wrapper">
        <iframe id="printPiApprovedMessage"></iframe>
      </div>
      <div v-else class="text-center text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загрузка...</strong>
      </div>
      <i v-if="piApprovedMessageHtml && piApprovedMessageHtml.length > 0 && (desktop || largeDesktop)"
         class="fas fa-print modal-print-document" title="Печать" @click="printDocument"></i>
      <i v-if="piApprovedMessageHtml && piApprovedMessageHtml.length > 0 && (desktop || largeDesktop)"
         class="fas fa-download modal-download-document" title="Скачать"
         @click="downloadFile($event, url, fileName, fts, fts_pi)"></i>
    </b-modal>

  </b-container>
</template>

<script>
/* eslint camelcase: ["error", {allow: ["^fts_pi", "^chain_id", "^data_created_package", "^pi_pid", "^consignment_id", "^print_docs", "^transite_pid", "^print_pi_docs", "^open_documents", "^current_status"]}] */

import moment from 'moment'
import { mapActions, mapMutations, mapState } from 'vuex'
import PiTransitActionButtons from './PiTransitActionButtons'

export default {
  name: 'Consignments',
  components: {
    ModalPackageForm: () => import('./ModalPackageForm'),
    PiTransitActionButtons
  },
  data () {
    return {
      consignmentsInfo: '',
      url: null,
      fileName: null,
      fts: null,
      fts_pi: null,
      consignmentId: null,
      editFiles: [],
      filesToDelete: [],
      attachmentWidth: null,
      deletedFilesCount: 0,
      sendConsignmentFlag: false,
      fields: [],
      isBusy: false,
      currentPage: 1,
      totalRows: null,
      perPage: 10,
      pageOptions: [10, 20, 50],
      sortBy: 'chain_id',
      sortDesc: true,
      sortDirection: 'desc',
      pageOptionSelected: 10,
      filter: null,
      message: null,
      data_created_package: null,
      chainId: null,
      piPid: null,
      dismissSecs: 5,
      openModal: false,
      striped: false,
      stacked: false,
      fixed: false
    }
  },
  watch: {
    mobile (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    },
    tablet (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    },
    desktop (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    },
    largeDesktop (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    }
  },
  beforeMount () {
    this.setServerAlias()
  },
  mounted () {
    this.setTableFields()
    this.attachmentWidth = Math.round((window.innerWidth - 16 * 9 - 30) / 8)
    this.attachmentWidth = this.attachmentWidth < 218 ? 218 : this.attachmentWidth
    this.toggleBusy()
    this.loadConsignments().then(
      () => {
        this.toggleBusy()
        this.totalRows = this.parsedConsignments.length
        this.loadCustomsMessages()
      },
      error => {
        console.log(error)
        this.toggleBusy()
      }
    )
    this.getStatuses()
  },
  beforeRouteLeave (to, from, next) {
    this.cancelSourceToken({ message: 'Operation canceled by the user' })
    next()
  },
  methods: {
    ...mapActions('piTransitOtvt', [
      'getStatuses',
      'loadConsignments',
      'createConsignment',
      'getConsignmentById',
      'addFiles',
      'deleteFiles',
      'syncFromPiportal',
      'addConsignmentToPiportal',
      'loadCustomsMessages',
      'loadFtsMessages',
      'showFtsMessageHtml',
      'getFile',
      'getFtsFile',
      'showPiApprovedMessageHtml',
      'getPiApprovedFtsFile'
    ]),
    ...mapMutations('piTransitOtvt', [
      'setCurrentStatus',
      'updatePackageCreated',
      'updateDismissCountDown1',
      'updatePackageEdited',
      'updateDismissCountDown2',
      'setServerAlias',
      'cancelSourceToken',
      'setFtsMessageHtml',
      'setPiApprovedMessageHtml'
    ]),
    setTableFields () {
      if (this.mobile) {
        this.fields = [
          { key: 'status', label: '№ Накладной / Статус', sortable: false },
          { key: 'transport', label: 'Транспорт', sortable: false },
          { key: 'transite_open', label: 'Транзит открыт', sortable: false },
          { key: 'transite_close', label: 'Транзит закрыт', sortable: false },
          { key: 'declaration', label: 'Номер ЭТД', sortable: false },
          { key: 'chain_id', label: '№ Заявки / Действия', sortable: false }
        ]
        this.striped = true
        this.stacked = true
        this.fixed = false
      }
      if (this.tablet) {
        this.fields = [
          { key: 'status', label: '№ Накладной / Статус', sortable: false },
          { key: 'transite_open', label: 'Транзит открыт / Транзит закрыт', sortable: false },
          { key: 'transport', label: '№ ЭТД / Транспорт', sortable: false },
          { key: 'chain_id', label: '№ Заявки / Действия', sortable: false }
        ]
        this.striped = true
        this.stacked = true
        this.fixed = false
      }
      if (this.desktop) {
        this.fields = [
          { key: 'status', label: 'Накладная', sortable: false },
          { key: 'transport', label: 'Транспорт', sortable: false },
          { key: 'transite_open', label: 'Транзит', sortable: false },
          { key: 'declaration', label: 'Номер ЭТД', sortable: false },
          { key: 'chain_id', label: 'Пакет', sortable: false },
          { key: 'show_details', label: 'Действия', sortable: false, tdClass: 'align-middle' }
        ]
        this.striped = false
        this.stacked = false
        this.fixed = true
      }
      if (this.largeDesktop) {
        this.fields = [
          { key: 'status', label: 'Накладная', sortable: false },
          { key: 'transport', label: 'Транспорт', sortable: false },
          { key: 'transite_open', label: 'Транзит открыт', sortable: false },
          { key: 'transite_close', label: 'Транзит закрыт', sortable: false },
          { key: 'declaration', label: 'Номер ЭТД', sortable: false },
          { key: 'chain_id', label: 'Пакет', sortable: false },
          { key: 'show_details', label: 'Действия', sortable: false, tdClass: 'align-middle' }
        ]
        this.striped = false
        this.stacked = false
        this.fixed = true
      }
    },
    setFirstItem () {
      if (this.parsedConsignments.length < 1) {
        return 0
      } else {
        return 1
      }
    },
    saveOptionSelected (event) {
      this.pageOptionSelected = event
    },
    calcItems () {
      if (this.currentPage === 1) {
        if ((this.currentPage) + this.pageOptionSelected < this.parsedConsignments.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.parsedConsignments.length
        }
      } else {
        if (((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected < this.parsedConsignments.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.parsedConsignments.length
        }
      }
    },
    downloadFile (event, file, name, fts, fts_pi) {
      event.stopPropagation()
      if (fts || fts_pi) {
        this.getFtsFile({ file: file, name: name }).then(
          result => {
            let temp = document.createElement('div')
            temp.innerHTML = result.data
            document.getElementById('content').appendChild(temp)
            temp.setAttribute('id', 'download-pdf')
            temp.setAttribute('style', 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; display: none')
            const style = document.createElement('style')
            style.innerHTML = '#header { padding: 10mm !important; } #custom-id { padding: 10mm !important; } h2 { font-size: 16pt; text-align: center; } h1 { font-size: 12pt; text-align: center; } .tripple { width: 33% !important; float: left !important } .page-footer img { height: 1.2cm !important } .page-footer img.sign { height: 4cm } .huge { font-size: 14px !important } p { font-size: 14px !important} body { background-color: transparent !important; text-align: left !important } .page { margin-top: 0mm !important; margin-bottom: 0mm !important; padding: 10mm !important; border: none !important } th { font-size: 14px !important } td, h2 { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important}'
            document.getElementById('content').appendChild(style)
            const width = (name === 'ПИ подтверждено') ? 794 : (name === 'Подтверждение о прибытии') ? 794 : 1000
            const opt = {
              margin: 0,
              filename: name + '.pdf',
              image: { type: 'jpeg', quality: 0.98 },
              pagebreak: { after: ['.page'] },
              html2canvas: { scale: 2, width: width, scrollY: 0, scrollX: 0 },
              jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
            }

            setTimeout(() => {
              import('../../node_modules/html2pdf.js/dist/html2pdf.js').then(html2pdf => {
                html2pdf.default().set(opt).from(document.getElementById('download-pdf').innerHTML).save().then(() => {
                  const pdf = document.getElementById('download-pdf')
                  pdf.parentNode.removeChild(pdf)
                  const style = document.getElementById('content').getElementsByTagName('style')
                  for (let i = 0; i < style.length; i++) {
                    style[i].parentNode.removeChild(style[i])
                  }
                  temp = null
                })
              })
            }, 600)
          },
          error => {
            console.log(error)
          }
        )
      } else {
        this.getFile({ file: file, name: name })
      }
    },
    printDocument () {
      if (document.getElementById('printDocument')) {
        document.getElementById('printDocument').contentWindow.print()
      }
      if (document.getElementById('printDocumentFts')) {
        document.getElementById('printDocumentFts').contentWindow.print()
      }
      if (document.getElementById('printPiApprovedMessage')) {
        document.getElementById('printPiApprovedMessage').contentWindow.print()
      }
    },
    loadFile (event, file, name, fts, fts_pi) {
      event.stopPropagation()
      this.url = file
      this.fileName = name
      this.fts = fts
      this.fts_pi = fts_pi
      if (fts) {
        this.$root.$emit('bv::show::modal', 'modalLoadFtsMessage', event)
        this.showFtsMessageHtml({ url: file }).then(
          () => {
            this.$nextTick(() => {
              this.addHtmlToIframe()
            })
          },
          error => {
            console.log(error)
          }
        )
      } else if (fts_pi) {
        this.$root.$emit('bv::show::modal', 'modalLoadPiApprovedMessage', event)
        this.showPiApprovedMessageHtml({ url: file }).then(
          () => {
            this.$nextTick(() => {
              this.addHtmlToIframe()
            })
          },
          error => {
            console.log(error)
          }
        )
      } else {
        const ext = name.split('.').pop()
        switch (ext) {
          case 'pdf':
          case 'tif':
          case 'jpg':
          case 'jpeg':
          case 'png':
          case 'gif':
          case 'xml':
          case 'txt':
            this.$root.$emit('bv::show::modal', 'modalLoadFile', event)
            break
          default:
            break
        }
      }
    },
    addStyle () {
      const img = document.getElementById('printDocument').contentWindow.document.getElementsByTagName('img')
      if (img.length > 0) {
        img[0].setAttribute('style', 'width: 100%')
      }
    },
    reloadConsignments () {
      this.toggleBusy()
      this.loadConsignments().then(
        () => {
          this.toggleBusy()
          this.totalRows = this.parsedConsignments.length
        },
        error => {
          console.log(error)
          this.toggleBusy()
        }
      )
    },
    showModal () {
      this.inputUpdate([])
      this.sendConsignmentFlag = false
    },
    hideModal () {
      this.url = null
      this.consignmentsInfo = ''
      this.deletedFilesCount = 0
      this.editFiles = []
      this.openModal = false
      this.fts = false
      this.fts_pi = false
    },
    dismissPackageCreated () {
      this.updatePackageCreated(0)
      this.updateDismissCountDown1(0)
    },
    dismissPackageEdited () {
      this.updatePackageEdited(0)
      this.updateDismissCountDown2(0)
    },
    countDownChanged1 (dismissCountDown) {
      this.updateDismissCountDown1(dismissCountDown)
    },
    countDownChanged2 (dismissCountDown) {
      this.updateDismissCountDown2(dismissCountDown)
    },
    onFiltered (parsedConsignments) {
      this.totalRows = parsedConsignments.length
      this.currentPage = 1
    },
    clearField () {
      this.filter = ''
    },
    recalcItemsLength () {
      if (!this.filter) {
        this.totalRows = this.parsedConsignments.length
        this.currentPage = 1
      }
    },
    updateConsignmentsInfo (value) {
      this.consignmentsInfo = value
    },
    rowHowered (item) {
      item.actions.visible = true
    },
    rowUnhowered (item) {
      item.actions.visible = false
    },
    toggleBusy () {
      this.isBusy = !this.isBusy
    },
    removeFileFromEditedFiles (id) {
      this.editFiles.filter(file => file.id === id)[0].deleted = true
      this.deletedFilesCount++
    },
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    convertDate (date) {
      return this.moment(date).format('DD.MM.YYYY')
    },
    validateChanges (event) {
      if ((this.files.length > 0 || this.deletedFilesCount > 0) && (!this.sendConsignmentFlag)) {
        const agree = confirm('Вы действительно хотите закрыть форму? Изменения, внесенные в пакет, не сохранятся!')
        if (!agree) event.preventDefault()
      }
    },
    inputUpdate (files) {
      this.$store.commit('updateFiles', files)
    },
    addHtmlToIframe () {
      if (this.fts) {
        document.getElementById('printDocumentFts').contentWindow.document.write(this.ftsMessageHtml)
      } else if (this.fts_pi) {
        document.getElementById('printPiApprovedMessage').contentWindow.document.write(this.piApprovedMessageHtml)
      }
    },
    openFormToAddConsignment () {
      this.$root.$emit('bv::show::modal', 'modalCreateConsignment', event)
    },
    saveNewConsignment (event) {
      event.stopPropagation()
      this.sendConsignmentFlag = true
      this.toggleBusy()
      this.createConsignment().then(
        result => {
          this.$root.$emit('bv::hide::modal', 'modalCreateConsignment', event)
          this.addFiles({ files: this.files }).then(
            result => {
              this.uploadConsignment({ saveNewConsignment: true })
            },
            error => {
              console.log(error)
              this.toggleBusy()
            }
          )
        },
        error => {
          console.log(error)
          this.toggleBusy()
        }
      )
    },
    openDocuments (row, chain_id, pi_pid, consignment_id, print_docs, transite_pid, print_pi_docs) {
      row.toggleDetails()
      if (!row.item.open_documents) {
        row.item.open_documents = !row.item.open_documents
        const objParams = {
          chain_id: chain_id,
          pi_pid: pi_pid,
          consignment_id: consignment_id,
          comment: null,
          row: row,
          param: 'open_documents',
          print_docs: print_docs,
          transite_pid: transite_pid,
          print_pi_docs: print_pi_docs
        }
        if (!consignment_id) {
          this.createConsignment().then(
            result => {
              this.getConsignment(objParams, row)
            },
            error => {
              console.log(error)
              if (row) {
                row.toggleDetails()
                row.item.open_documents = !row.item.open_documents
              }
            }
          )
        } else {
          this.getConsignment(objParams, row)
        }
      } else {
        row.item.open_documents = !row.item.open_documents
        row.item.files = null
      }
    },
    openFormToEditConsignment (chain_id, pi_pid, comment, consignment_id) {
      const objParams = {
        chain_id: chain_id,
        pi_pid: pi_pid,
        consignment_id: consignment_id,
        comment: comment,
        row: null,
        param: 'edit_form'
      }
      if (!consignment_id) {
        this.createConsignment().then(
          result => {
            this.getConsignment(objParams)
          },
          error => {
            console.log(error)
          }
        )
      } else {
        this.getConsignment(objParams)
      }
      this.$root.$emit('bv::show::modal', 'modalEditConsignment', event)
    },
    getConsignment (objParams, row) {
      this.syncFromPiportal({
        chain_id: objParams.chain_id,
        pi_pid: objParams.pi_pid,
        consignment_id: objParams.consignment_id
      }).then(
        result => {
          this.getConsignmentById({
            consignment_id: objParams.consignment_id
          }).then(
            result => {
              switch (objParams.param) {
                case 'edit_form':
                  this.consignmentId = this.consignment.id
                  this.chainId = objParams.chain_id
                  this.piPid = objParams.pi_pid
                  this.consignmentsInfo = this.consignment.info
                  this.data_created_package = moment(this.consignment.create_date).format('DD.MM.YYYY')
                  this.message = objParams.comment
                  for (let q = 0; q < this.consignment.files.length; q++) {
                    this.$set(this.editFiles, q,
                      {
                        name: this.consignment.files[q].name,
                        size: this.consignment.files[q].size,
                        link: this.consignment.files[q].file,
                        id: this.consignment.files[q].id,
                        deleted: false,
                        icon: this.consignment.files[q].icon
                      })
                  }
                  this.openModal = true
                  break
                case 'open_documents':
                  if (objParams.print_docs && !objParams.print_pi_docs) {
                    this.loadFtsMessages({ transite_pid: objParams.transite_pid }).then(
                      result => {
                        const documents = this.createFtsDocuments()
                        objParams.row.item.files = this.concatFilesDocuments(documents)
                      },
                      error => {
                        console.log(error)
                      }
                    )
                  } else if (objParams.print_docs && objParams.print_pi_docs) {
                    this.loadFtsMessages({ transite_pid: objParams.transite_pid }).then(
                      result => {
                        const documents = this.createFtsDocuments()
                        documents.unshift({
                          name: 'ПИ подтверждено',
                          size: null,
                          file: '/api/private/v3.0/piportals/' + this.alias + '/packages/' + objParams.pi_pid + '/pi-print',
                          id: 'pi_approved',
                          fts: false,
                          fts_pi: true,
                          date: null,
                          icon: 'fas fa-print green'
                        })
                        objParams.row.item.files = this.concatFilesDocuments(documents)
                      },
                      error => {
                        console.log(error)
                      }
                    )
                  } else if (!objParams.print_docs && objParams.print_pi_docs) {
                    const concatFilesDocuments = this.consignment.files.slice()
                    concatFilesDocuments.push({
                      name: 'ПИ подтверждено',
                      size: null,
                      file: '/api/private/v3.0/piportals/' + this.alias + '/packages/' + objParams.pi_pid + '/pi-print',
                      id: 'pi_approved',
                      fts: false,
                      fts_pi: true,
                      date: null,
                      icon: 'fas fa-print green'
                    })
                    objParams.row.item.files = concatFilesDocuments
                  } else {
                    objParams.row.item.files = this.consignment.files
                  }
                  break
                default:
                  break
              }
              this.parsedConsignments.filter(consignment => consignment.chain_id === objParams.chain_id)[0].consignment_id = this.consignment.id
            },
            error => {
              console.log(error)
            }
          )
        },
        error => {
          console.log(error)
          if (row) {
            row.toggleDetails()
            row.item.open_documents = !row.item.open_documents
          }
        }
      )
    },
    createFtsDocuments () {
      const documents = []
      for (let q = 0; q < this.ftsMessages.length; q++) {
        this.$set(documents, q,
          {
            name: this.customsMessages.filter(message => message.code === this.ftsMessages[q].messagecode)[0].name,
            size: null,
            file: '/api/private/v3.0/piportals/' + this.alias + '/packages/' + this.ftsMessages[q].pid + '/pitransite-messages/' + this.ftsMessages[q].id + '/view/',
            id: this.ftsMessages[q].id,
            fts: true,
            fts_pi: false,
            date: this.ftsMessages[q].preparationdatetime,
            icon: 'fas fa-print green'
          }
        )
      }
      return documents.reverse()
    },
    concatFilesDocuments (documents) {
      const concatFilesDocuments = this.consignment.files.slice()
      for (let i = 0; i < documents.length; i++) {
        concatFilesDocuments.push(documents[i])
      }
      return concatFilesDocuments
    },
    saveEditedConsignment (event) {
      event.stopPropagation()
      this.sendConsignmentFlag = true
      this.toggleBusy()
      const filesToDelete = []
      const filesNotToDelete = []
      for (let i = 0; i < this.editFiles.length; i++) {
        if (this.editFiles[i].deleted) {
          filesToDelete.push(this.editFiles[i].id)
        } else {
          filesNotToDelete.push({ id: this.editFiles[i].id, name: this.editFiles[i].name })
        }
      }
      for (let n = 0; n < filesNotToDelete.length; n++) {
        for (let m = 0; m < this.files.length; m++) {
          if (filesNotToDelete[n].name === this.files[m].name) {
            filesToDelete.push(filesNotToDelete[n].id)
            break
          }
        }
      }
      if (filesToDelete.length > 0) {
        this.deleteFiles({
          consignment_id: this.consignmentId,
          filesToDelete: filesToDelete
        }).then(
          result => {
            this.$root.$emit('bv::hide::modal', 'modalEditConsignment', event)
            this.addFiles({
              consignment_id: this.consignmentId,
              files: this.files
            }).then(
              result => {
                this.uploadConsignment({ saveNewConsignment: false })
              },
              error => {
                console.log(error)
                this.toggleBusy()
              }
            )
          },
          error => {
            console.log(error)
            this.toggleBusy()
          }
        )
      } else {
        this.addFiles({
          consignment_id: this.consignmentId,
          files: this.files
        }).then(
          result => {
            this.$root.$emit('bv::hide::modal', 'modalEditConsignment', event)
            this.uploadConsignment({ saveNewConsignment: false })
          },
          error => {
            console.log(error)
            this.toggleBusy()
          }
        )
      }
    },
    uploadConsignment (param) {
      this.addConsignmentToPiportal({
        chain_id: param.saveNewConsignment ? null : this.chainId,
        consignment_id: param.saveNewConsignment ? null : this.consignmentId,
        pi_pid: param.saveNewConsignment ? null : this.piPid
      }).then(
        result => {
          this.loadConsignments().then(
            result => {
              param.saveNewConsignment ? this.updatePackageCreated(1) : this.updatePackageEdited(1)
              param.saveNewConsignment ? this.updateDismissCountDown1(this.dismissSecs) : this.updateDismissCountDown2(this.dismissSecs)
              this.toggleBusy()
              this.sendConsignmentFlag = false
            },
            error => {
              console.log(error)
              this.toggleBusy()
            }
          )
        },
        error => {
          console.log(error)
        }
      )
    },
    copyPkgNumber (id, param, event) {
      event.stopPropagation()
      if (param === 'add') {
        this.copyTextToClipboard(id, this.chainPid, event)
      }
      if (param === 'edit') {
        this.copyTextToClipboard(id, this.chainId, event)
      }
    },
    copyTextToClipboard (id, value, event) {
      event.stopPropagation()
      const copyedText = value.toString()
      const textArea = document.createElement('textarea')
      textArea.value = copyedText
      document.body.appendChild(textArea)
      textArea.select()
      try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        this.$root.$emit('bv::hide::tooltip', id.toString())
        event.target.setAttribute('data-original-title', 'Скопировано')
        event.target.setAttribute('style', 'color: #40b539')
        this.$root.$emit('bv::show::tooltip', id.toString())
        console.log('Fallback: Copying text command was ' + msg)
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }
      document.body.removeChild(textArea)
    },
    resetTooltip (text, event) {
      this.$root.$emit('bv::hide::tooltip', text.toString())
      event.target.setAttribute('data-original-title', 'Копировать')
      event.target.setAttribute('style', 'color: #78909C')
    },
    calcFileSize (FileSize) {
      const FileSizeInKb = Math.floor(FileSize / 1024)
      let FileSizeInMb = 0
      let FileSizeInGb = 0
      if (FileSizeInKb > 0) {
        FileSizeInMb = Math.floor(FileSizeInKb / 1024)
        if (FileSizeInMb > 0) {
          FileSizeInGb = Math.floor(FileSizeInMb / 1024)
          if (FileSizeInGb > 0) {
            return FileSizeInGb + ' Гб'
          } else {
            return FileSizeInMb + ' Мб'
          }
        } else {
          return FileSizeInKb + ' Кб'
        }
      } else {
        return FileSize + ' байт'
      }
    }
  },
  computed: {
    ...mapState(
      {
        consignments: state => state.piTransitOtvt.consignments,
        arrOfIcons: state => state.piTransitOtvt.arrOfIcons,
        files: state => state.files,
        selectVal: state => state.piTransitOtvt.selectVal,
        statuses: state => state.piTransitOtvt.statuses,
        consignment: state => state.piTransitOtvt.consignment,
        dismissCountDown1: state => state.piTransitOtvt.dismissCountDown1,
        dismissCountDown2: state => state.piTransitOtvt.dismissCountDown2,
        packageEdited: state => state.piTransitOtvt.packageEdited,
        packageCreated: state => state.piTransitOtvt.packageCreated,
        chainPid: state => state.piTransitOtvt.pid,
        customsMessages: state => state.piTransitOtvt.customsMessages,
        ftsMessages: state => state.piTransitOtvt.ftsMessages,
        ftsMessageHtml: state => state.piTransitOtvt.ftsMessageHtml,
        piApprovedMessageHtml: state => state.piTransitOtvt.piApprovedMessageHtml,
        alias: state => state.piTransitOtvt.alias,
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop,
        userInfo: state => state.authorization.userInfo
      }
    ),
    current_status: {
      get () {
        return this.$store.state.piTransitOtvt.selectVal.current_status
      },
      set (status) {
        this.setCurrentStatus(status)
      }
    },
    parsedConsignments () {
      if (this.consignments && this.consignments.length > 0) {
        return JSON.parse(JSON.stringify(this.consignments)).filter(item => {
          let keep = true
          this.fieldKeys.forEach(key => {
            keep = keep && (this.selectVal[key] === undefined || item[key] === this.selectVal[key])
          })
          return keep
        })
      } else {
        return []
      }
    },
    fieldKeys () {
      return Object.keys(this.consignments[0])
    }
  },
  destroyed () {
    this.setCurrentStatus(undefined)
  }
}
</script>

<style lang="scss" scoped>
  .copy-td {
    cursor: pointer;
  }

  #select-status {
    font-size: 14px;
    height: 40px;
  }

  .data_table_icon {
    width: 20px;
    height: 20px;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    margin-right: 8px;
  }

  #create-new-consignment {
    height: 40px;
    i {
      color: #ffffff;
      @extend .data_table_icon;
    }
    span {
      font-size: 14px;
      font-weight: 500;
      position: relative;
      bottom: 1px;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1023px) {
    #create-new-consignment {
      width: calc(50% - 8px);
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1439px) {
    #create-new-consignment {
      width: 170px;
    }
  }

  @media screen and (min-width: 1440px) {
    #create-new-consignment {
      width: 213px;
    }
  }

  select {
    -webkit-appearance: none;
    cursor: pointer;
  }

  .input-group {
    .form-control:not(:last-child), .custom-select:not(:last-child) {
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
      font-size: 14px;
      height: 40px;
    }
  }

  .container_search-close {
    position: absolute;
    right: 11px;
    top: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    z-index: 4;
    &:hover {
      border-radius: 50%;
      background-color: #acacac;
      span {
        color: #fff;
      }
    }
    .search-close {
      font-size: 18px;
      color: #acacac;
      cursor: pointer;
      line-height: 18px;
      width: 18px;
      text-align: center;
      margin-bottom: 2px;
    }
  }

  #find-consignments {
    height: 40px;
    i {
      color: #ffffff;
      @extend .data_table_icon;
    }
    span {
      font-size: 14px;
      font-weight: 500;
      position: relative;
      bottom: 1px;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1023px) {
    #find-consignments {
      width: calc(50% - 8px)
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1439px) {
    #find-consignments {
      width: 170px;
    }
  }

  @media screen and (min-width: 1440px) {
    #find-consignments {
      width: 213px;
    }
  }

  .filtered-items-number {
    font-size: 14px;
  }

  #data_table {
    .invoice-wrapper {
      position: relative;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      i {
        color: #78909C;
        @extend .data_table_icon;
      }
      .invoice {
        color: #37474F;
        font-size: 20px;
        line-height: 24px;
        font-weight: 500;
      }
    }
    @media only screen and (min-width: 768px) {
      .invoice-wrapper {
        width: 50%;
      }
      .status-wrapper {
        width: 50%;
      }
    }
    .status-badge {
      height: 24px;
      line-height: 16px;
      font-size: 14px;
    }
    .reply-icon-wrapper {
      i {
        font-size: 21px;
      }
      width: 21px;
      height: 21px;
    }
    .transit-wrapper {
      position: relative;
      i {
        color: #78909C;
        @extend .data_table_icon;
      }
      .transit-status {
        color: #373A3C;
        font-size: 14px;
        letter-spacing: 0.25px;
        line-height: 20px;
      }
      .transit-date {
        color: #37474F;
        font-size: 16px;
        font-weight: 500;
        position: absolute;
        top: 0px;
      }
      @media screen and (min-width: 1440px) {
        .transit-date {
          right: 0px;
          margin-left: 8px;
        }
      }
      .transit-station {
        color: #373A3C;
        font-size: 14px;
        letter-spacing: 0.25px;
        line-height: 20px;
      }
    }
    @media only screen and (min-width: 768px) and (max-width: 1023px) {
      .transit-wrapper {
        width: 50%;
      }
    }
    .vehicle {
      i {
        color: #78909C;
        @extend .data_table_icon;
      }
      div {
        width: 50%;
      }
    }
    .consignment {
      i {
        color: #78909C;
        @extend .data_table_icon;
      }
      div {
        width: 50%;
      }
    }
    .action-button {
      width: 34px;
    }
    .td-number-wrapper {
      position: relative;
      word-break: break-all;
      .td-number {
        font-size: 16px;
        color: #37474F;
        font-weight: 500;
        line-height: 20px;
      }
      i {
        color: #78909C;
        @extend .data_table_icon;
      }
    }
    .package-number-wrapper {
      i {
        color: #78909C;
        @extend .data_table_icon;
      }
      .package-number {
        color: #37474F;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
      }
    }
    .created-date-wrapper {
      i {
        color: #78909C;
        @extend .data_table_icon;
      }
      .created-date {
        color: #373A3C;
        font-size: 14px;
        letter-spacing: 0.25px;
        line-height: 20px;
      }
    }
    .user-creator-wrapper {
      i {
        color: #78909C;
        @extend .data_table_icon;
      }
      .user-creator {
        color: #373A3C;
        font-size: 14px;
        letter-spacing: 0.25px;
        line-height: 20px;
      }
    }
    .attachments-wrapper {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      .attachment {
        margin-right: 16px;
        margin-bottom: 16px;
        padding: 10px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
        position: relative;
        &:hover {
          box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
          cursor: pointer;
        }
        .attachment-inner-container {
          display: flex;
          width: 100%;
          word-break: break-all;
          .file-icon-wrapper {
            margin-right: 10px;
            i {
              font-size: 32px;
              color: #78909C;
              min-height: 80px;
            }
            .green {
              color: #40b539;
            }
          }
          .attachment-name-wrapper {
            font-size: 14px;
            letter-spacing: 0.25px;
            line-height: 20px;
            color: #37474F;
            .file-size {
              position: absolute;
              right: 10px;
              bottom: 10px;
            }
            .file-date {
              position: absolute;
              right: 10px;
              bottom: 10px;
            }
          }
          .download-file-wrapper {
            width: 32px;
            height: 32px;
            line-height: 32px;
            position: absolute;
            bottom: 15px;
            left: 10px;
            color: #78909C;
            i {
              font-size: 32px;
              position: relative;
              top: 6px;
            }
            &:hover {
              color: #40b539;
            }
          }
        }
      }
      @media only screen and (min-width: 320px) {
        .attachment {
          margin-left: 8px;
          margin-right: 8px;
        }
      }
    }
    @media screen and (min-width: 320px) and (max-width: 1023px) {
      .attachments-wrapper {
        justify-content: center;
      }
    }
    .no-files {
      padding-bottom: 16px;
    }
  }

  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .iframe-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 25px;
    height: 0;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .modal-print-document {
    font-size: 32px;
    width: 32px;
    height: 32px;
    color: #78909c;
    position: absolute;
    top: -35px;
    left: 17px;
    cursor: pointer;
  }

  .modal-print-document:hover {
    color: #40b539;
  }

  .modal-download-document {
    font-size: 32px;
    width: 32px;
    height: 32px;
    color: #78909c;
    position: absolute;
    top: -35px;
    left: 70px;
    cursor: pointer;
  }

  .modal-download-document:hover {
    color: #40b539;
  }
</style>
